import { CKCardCollapsible } from '@clearkit/react';

import EmptyFieldMappingFields from '../EmptyFieldMappingFields';
import FieldMappingFooter from '../FieldMappingFooter';
import FieldMappingFormFields from '../FieldMappingFormFields';
import FieldMappingHeaders from '../FieldMappingHeaders';
import FieldMappingHeader from './FieldMappingHeader';

const BetaFieldMappingForm = ({
  integration,
  objectType,
  addMapping,
  areFieldMappingsValid,
  isUpdating,
  setConfirmSaveDialogOpen,
  setShowInvalidFields,
  fieldMappings,
  fieldErrors,
  sortedMappings,
  handleMappingChange,
  applyChangesToAllGroupMembers,
  removeMappingGroup,
  removeMapping,
  onClickRefreshAttributes,
  showInvalidFields,
  targetAttributes,
  sourceAttributes,
  hasEnrichmentBetaUIFlag,
}) => {
  return (
    <CKCardCollapsible
      className="mt-10"
      header={
        <FieldMappingHeader
          integration={integration}
          fieldMappings={fieldMappings}
        />
      }>
      {fieldMappings.length === 0 ? (
        <EmptyFieldMappingFields
          integration={integration}
          objectType={objectType}
          addMapping={addMapping}
          hasEnrichmentBetaUIFlag={hasEnrichmentBetaUIFlag}
        />
      ) : (
        <div>
          <FieldMappingHeaders hasEnrichmentBetaUIFlag />
          <FieldMappingFormFields
            fieldErrors={fieldErrors}
            sortedMappings={sortedMappings}
            handleMappingChange={handleMappingChange}
            applyChangesToAllGroupMembers={applyChangesToAllGroupMembers}
            removeMappingGroup={removeMappingGroup}
            removeMapping={removeMapping}
            addMapping={addMapping}
            objectType={objectType}
            sourceAttributes={sourceAttributes}
            targetAttributes={targetAttributes}
            integration={integration}
            showInvalidFields={showInvalidFields}
            onClickRefreshAttributes={onClickRefreshAttributes}
            hasEnrichmentBetaUIFlag={hasEnrichmentBetaUIFlag}
          />
        </div>
      )}

      <FieldMappingFooter
        className="px-6 pt-6 mt-6 -mx-6 border-t border-gray-100"
        isUpdating={isUpdating}
        areFieldMappingsValid={areFieldMappingsValid}
        addMapping={addMapping}
        setShowInvalidFields={setShowInvalidFields}
        setConfirmSaveDialogOpen={setConfirmSaveDialogOpen}
        hasEnrichmentBetaUIFlag={hasEnrichmentBetaUIFlag}
      />
    </CKCardCollapsible>
  );
};

export default BetaFieldMappingForm;
